import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Card,
  CardBody,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import Swal from "sweetalert2";
import Header from "components/Headers/Header";
import Cookies from "universal-cookie";

const ReporteDistribuidor = () => {
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [regionalSeleccionada, setRegionalSeleccionada] = useState("");
  const [regionales, setRegionales] = useState([]);
  const [loading, setLoading] = useState(false);
  const cookie = new Cookies();
  useEffect(() => {
    obtenerRegionales();
  }, []);

  const obtenerRegionales = async () => {
    try {
      const response = await axios.get(
        "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerRegional",
      );
      setRegionales(response.data);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudieron cargar las regionales.", "error");
    }
  };

  const descargarExcel = async () => {
    // ✅ Validar fechas obligatorias
    if (!fechaInicio || !fechaFin) {
      Swal.fire(
        "Campos requeridos",
        "Debes seleccionar fecha inicio y fecha fin.",
        "warning",
      );
      return;
    }

    // ✅ Validar rango correcto
    if (fechaInicio > fechaFin) {
      Swal.fire(
        "Fechas inválidas",
        "La fecha inicio no puede ser mayor a la fecha fin.",
        "warning",
      );
      return;
    }

    // ✅ Si selecciona TODAS se envía vacío
    const regionalFinal =
      regionalSeleccionada === "TODAS" ? "" : regionalSeleccionada;

    const payload = {
      regional: regionalFinal,
    };

    const url = `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerGnvExternos/${fechaInicio}/${fechaFin}/${cookie.get("id")}`;

    setLoading(true);

    try {
      const response = await axios.post(url, payload, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Distribuidor_${fechaInicio}_a_${fechaFin}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);

      Swal.fire("Éxito", "El reporte se descargó correctamente.", "success");
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Ocurrió un error al descargar el reporte.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Card className="shadow mb-4">
          <CardBody>
            <h4 className="mb-4">Reportes Distribución</h4>

            <Form>
              <Row form>
                <Col md={4}>
                  <FormGroup>
                    <Label>Fecha Inicio</Label>
                    <Input
                      type="date"
                      value={fechaInicio}
                      onChange={(e) => setFechaInicio(e.target.value)}
                    />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <Label>Fecha Fin</Label>
                    <Input
                      type="date"
                      value={fechaFin}
                      onChange={(e) => setFechaFin(e.target.value)}
                    />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <Label>Regional</Label>
                    <Input
                      type="select"
                      value={regionalSeleccionada}
                      onChange={(e) => setRegionalSeleccionada(e.target.value)}
                    >
                      <option value="">Seleccione una regional</option>
                      <option value="TODAS">Todas</option>

                      {regionales.map((reg, index) => (
                        <option key={index} value={reg.nombre}>
                          {reg.nombre}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>

              <div className="text-right">
                <Button
                  color="success"
                  onClick={descargarExcel}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner size="sm" className="mr-2" />
                      Descargando...
                    </>
                  ) : (
                    "Descargar Excel"
                  )}
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default ReporteDistribuidor;
